import { render, staticRenderFns } from "./MonthPressPurchaseList.vue?vue&type=template&id=9fc439a2&"
import script from "./MonthPressPurchaseList.vue?vue&type=script&lang=js&"
export * from "./MonthPressPurchaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports